export const ROLES = ['SUPER_ADMIN', 'ADMIN', 'ORGANIZATION_ADMIN', 'NATIONAL_USER', 'STATE'];
